import { createContext, ReactNode, useContext, useState } from "react";

interface IContextProps {
  scale: number;
  setScale: (val: number) => void;
}

const ScaleContext = createContext<IContextProps>({
  scale: 1,
  setScale: () => {},
});

interface ScaleProviderProps {
  children: ReactNode;
}

export const ScaleProvider: React.FC<ScaleProviderProps> = ({ children }) => {
  const [scale, setScale] = useState(1);

  return (
    <ScaleContext.Provider value={{ scale, setScale }}>
      {children}
    </ScaleContext.Provider>
  );
};

export const useScaleContext = () => useContext(ScaleContext);

export default useScaleContext;
